import getStore from '../store/store';

export default function isAnyFilterApplied() {
    const {
        roomFilterState: { selectedFilters, shouldGetSpaces },
        roomListPickerViewState: { selectedOption },
    } = getStore();

    return !!selectedFilters?.length || !!selectedOption || !!shouldGetSpaces;
}
